module.exports = __webpack_public_path__ + "img/tpc-42.57294690.jpg";